module.exports = __webpack_public_path__ + "static/media/melhorenvio.4e0fbaba.svg";